export default "__VITE_ASSET__Bfmjkyn3__"